module.exports = __webpack_public_path__ + "static/media/28.6b12657d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/28.png
// module id = 1467
// module chunks = 0